'use strict';

module.exports = function () {
    $(window).on('load', function () {
        if ($('h1').length > 1) {
            $($('h1 a.logo-home')[0]).unwrap();
        }
    });
}